module.exports = __webpack_public_path__ + "static/media/checkbox-checked-purple.39470f91.svg";